/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
export default class ButtonStates {
    /**
     * @param {PIXI.Texture} normal
     * @param {PIXI.Texture} [over]
     * @param {PIXI.Texture} [down]
     * @param {PIXI.Texture} [icon]
     */
    constructor(normal, over, down, icon) {
        /**
         * @member {PIXI.Texture}
         */
        this.normal = normal;

        /**
         * @member {PIXI.Texture}
         */
        this.over = over || null;

        /**
         * @member {PIXI.Texture}
         */
        this.down = down || null;

        /**
         * @member {PIXI.Texture}
         */
        this.focus = null;

        /**
         * @member {PIXI.Texture}
         */
        this.icon = icon || null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconOver = null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconDown = null;

        /**
         * @member {PIXI.Texture}
         */
        this.normalAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.overAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.downAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconOverAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconDownAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.normalInactive = null;

        /**
         * @member {PIXI.Texture}
         */
        this.overInactive = null;

        /**
         * @member {PIXI.Texture}
         */
        this.downInactive = null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconInactive = null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconOverInactive = null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconDownInactive = null;

        /**
         * @member {PIXI.Texture}
         */
        this.normalInactiveAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.overInactiveAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.downInactiveAlt = null;

        /**
         * @member {PIXI.Texture}
         */
        this.iconInactiveAlt = null;
    }

    /**
     * @returns {ButtonStates}
     */
    clone() {
        const states = new ButtonStates(this.normal);
        states.over = this.over;
        states.down = this.down;
        states.over = this.over;
        states.focus = this.focus;
        states.icon = this.icon;
        states.iconOver = this.iconOver;
        states.iconDown = this.iconDown;
        states.normalAlt = this.normalAlt;
        states.downAlt = this.downAlt;
        states.overAlt = this.overAlt;
        states.iconAlt = this.iconAlt;
        states.iconOverAlt = this.iconOverAlt;
        states.iconDownAlt = this.iconDownAlt;
        states.normalInactive = this.normalInactive;
        states.downInactive = this.downInactive;
        states.overInactive = this.overInactive;
        states.iconInactive = this.iconInactive;
        states.iconDownInactive = this.iconDownInactive;
        states.iconOverInactive = this.iconOverInactive;
        states.normalInactiveAlt = this.normalInactiveAlt;
        states.downInactiveAlt = this.downInactiveAlt;
        states.overInactiveAlt = this.overInactiveAlt;
        states.iconInactiveAlt = this.iconInactiveAlt;
        return states;
    }
}